import styled from 'styled-components'

export const VideoContainerStyled = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;

  iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100vw;
    height: 100vh;
    transform: translate(-50%, -50%);
    border: 0;
  }
`

export const ContentStyled = styled.div`
  position: absolute;
  font-size: 24px;
  color: var(--text);
  background: rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
  max-width: 10vw;
  min-width: 200px;

  &.game-info-container {
    top: 10vh;
    right: 6vw;
    padding: 40px 32px;
    text-align: center;

    > * {
      position: relative;
    }
  }

  &.playlist-container {
    left: 6vw;
    bottom: 4vh;
    font-size: 14px;
    padding: 20px;
    max-width: 25vw;

    h2 {
      font-size: 1.5em;
      position: relative;
      margin: 0 0 10px;
      padding: 0.5em;
    }

    .playlist {
      padding-bottom: 0;
    }
  }

  &:before {
    content: '';
    filter: blur(12px);
    width: 100%;
    height: 100%;
    flex: 1;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
  }
`

export const OverlayStyled = styled.div`
  width: 100vw;
  height: 100vh;
  mix-blend-mode: darken;
  background-color: rgba(0, 0, 0, 0.33);
`
